import { ApiBase } from "@/api/ApiBase";
import type { Representante, UlemoLicence, UserAuth } from "@/api/session";

export interface AutenticarResponse {
  msg: string;
  tipo: "erro" | "sucesso";
}

export interface UsuarioAutenticadoResponse {
  userAuth: UserAuth | null;
}

export interface LicencaInstalacaoResponse {
  ulemoLicence: UlemoLicence;
  representante: Representante | null;
  estaEmProducao: boolean;
}

export interface AutoCadastrarPayload {
  nome: string;
  tipo: "Empresa" | "Particular";
  nif: string;
  telefone: string;
  SENHA: string;
  SENHA2: string;
  codigoIndicacao?: string;
}

export interface VerificaCodigoIndicacaoResponse {
  valido: boolean;
  nomeParceiro: string | null;
}

export interface SolicitarRecuperacaoResponse {
  msg: string;
  tipo: "erro" | "sucesso";
  codigoConfirmacaoId: number | null;
}

export class AuthApi extends ApiBase {
  autenticar(userName: string, userPass: string): Promise<AutenticarResponse> {
    return this.http.post<AutenticarResponse>("/api/auth-conta/autenticar", {
      userName,
      userPass,
    });
  }

  autoCadastrar(payload: AutoCadastrarPayload): Promise<AutenticarResponse> {
    return this.http.post<AutenticarResponse>(
      "/api/comerciante/auto-cadastrar",
      {
        nome: payload.nome,
        tipo: payload.tipo,
        nif: payload.nif,
        telefone: payload.telefone,
        SENHA: payload.SENHA,
        SENHA2: payload.SENHA2,
        ...(payload.codigoIndicacao
          ? { codigoIndicacao: payload.codigoIndicacao }
          : {}),
      },
    );
  }

  /** Confirma se um código de indicação de parceiro (vindo de um link de
   * registo, ex.: /criar-conta/CODIGO) corresponde mesmo a um parceiro —
   * usado para decidir se se mostra o formulário normal ou se se redirecciona
   * em silêncio, sem incomodar o visitante com um erro técnico. */
  verificaCodigoIndicacao(
    codigo: string,
  ): Promise<VerificaCodigoIndicacaoResponse> {
    return this.http.put<VerificaCodigoIndicacaoResponse>(
      `/api/comerciante/verifica-codigo-indicacao/${encodeURIComponent(codigo)}`,
    );
  }

  usuarioAutenticado(): Promise<UsuarioAutenticadoResponse> {
    return this.http.put<UsuarioAutenticadoResponse>(
      "/api/auth-conta/user-autenticado",
    );
  }

  licencaInstalacao(): Promise<LicencaInstalacaoResponse> {
    return this.http.put<LicencaInstalacaoResponse>(
      "/api/auth-conta/licenca",
    );
  }

  logout(): Promise<void> {
    return this.http.get<void>("/logout");
  }

  solicitarRecuperacaoSenha(
    telefone: string,
  ): Promise<SolicitarRecuperacaoResponse> {
    return this.http.post<SolicitarRecuperacaoResponse>(
      "/api/auth-conta/solicitar-recuperacao-da-senha",
      { TELEFONE_ASSOCIADO: telefone },
    );
  }

  redefinirSenha(
    id: string,
    codigo: string,
    novaSenha: string,
    novaSenhaConfirma: string,
  ): Promise<AutenticarResponse> {
    return this.http.post<AutenticarResponse>(
      "/api/auth-conta/redefinir-a-senha",
      {
        id,
        codigo,
        NOVA_SENHA: novaSenha,
        NOVA_SENHA_CONFIRMA: novaSenhaConfirma,
      },
    );
  }
}
